import styled from 'styled-components'
import { swaapPurple0, swaapPurple1, swaapPurple2 } from '../../Themes'
import { buttonShadow } from './button-shadow'
import { tabletSize } from '../screen-sizes'

export const PopupButton = styled.button`
  font-family: Montserrat;
  height: 48px;
  font-size: 1.6rem;

  padding: 0 20px;
  min-width: 120px;
  background-color: white;
  transition: background-color 0.2s linear, color 0.2s linear;
  border-radius: 24px;
  border: none;
  color: ${swaapPurple2};
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  &:hover {
    background-color: ${swaapPurple2};
    color: white;
  }
  &:active {
    background-color: ${swaapPurple0};
    color: ${swaapPurple1};
  }

  @media (min-width: ${tabletSize}) {
    min-width: 250px;
  }
  @media (max-width: ${tabletSize}) {
    min-width: 250px;
    height: 44px;
    font-size: 1.4rem;
  }
`

// Put a span tag to ensure centered
export const PopupLinkButton = styled.a`
  font-family: Montserrat;
  display: flex;
  justify-content: center;
  align-items: center;

  height: 48px;
  font-size: 1.6rem;

  padding: 20px 20px;

  background-color: white;
  transition: background-color 0.2s linear, color 0.2s linear;
  border-radius: 24px;
  border: none;
  color: ${swaapPurple2};
  cursor: pointer;
  text-align: center;
  text-decoration: none;

  svg {
    path {
      stroke: ${swaapPurple2}!important;
    }
  }

  &:hover {
    background-color: ${swaapPurple2};
    color: white;
    svg {
      path {
        stroke: white !important;
      }
    }
  }
  &:active {
    background-color: ${swaapPurple0};
    color: ${swaapPurple1};
  }

  min-width: 250px;
  @media (min-width: ${tabletSize}) {
  }
  @media (max-width: ${tabletSize}) {
    height: 44px;
    font-size: 1.4rem;
  }
`
